import { Component, OnInit } from '@angular/core';
import { Router,ActivatedRoute} from '@angular/router';
import { StudentOpportunityService } from '../../_services/student-opportunity.service';
import swal from 'sweetalert2';

@Component({
  selector: 'app-student-opportunities',
  templateUrl: './student-opportunities.component.html',
  styleUrls: ['./student-opportunities.component.css'],
  providers:[StudentOpportunityService]
})
export class StudentOpportunitiesComponent implements OnInit {
  public currentUser: any;
  public currentUserName: any;
  personid;
  resData;
  currentOppId;
  letOppId;
  oppDataById;
  getAllOpportunities = [];
  loading = false;

  constructor( public route: ActivatedRoute,public srs:StudentOpportunityService,public router:Router) { 
    this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
    console.log(this.currentUser);
    this.currentUserName = this.currentUser.firstname + ' ' + this.currentUser.lastname;
    //Object.assign(this, {this.single, multi})
    this.personid=this.currentUser.personid;
  }

  ngOnInit() {
    this.route.params.subscribe(res => {
      this.currentOppId = res.oid;
    });
    
    this.getOpportunities();
    
  }
  getOpportunityById(oid)
  {
    this.loading = true;
     this.srs.getOpportunityById(oid,this.personid)
     .subscribe(res=>
    {
      this.resData=res;
      if(this.resData.status==1)
      {
         this.oppDataById=this.resData.data;
         //console.log(this.oppDataById)
      }
      else
      {
        console.log(this.resData.message)
      }
      this.loading = false;
    })
  }
  getOpportunities()
  {
    this.loading = true;
   this.srs.getopportunities(this.personid)
   .subscribe(res=>
  {
    this.resData=res;
    this.loading = false;
    if(this.resData.status==1)
    {
      if(this.resData.data.length>0)
      {
       this.letOppId=this.resData.data[0]['id'];
       this.getAllOpportunities=this.resData.data;
       if(this.currentOppId)
        {
          this.getOpportunityById(this.currentOppId);
        }
        else
        {
           
          this.getOpportunityById(this.letOppId);
        }
      }
    }
  })
  }
  navigateToView(id)
  {
    this.router.navigate(['/student-opportunities/'+id]);
    this.currentOppId = id;
    this.getOpportunityById(this.currentOppId);
  }
  removeOpportunity(id)
  {
    
    /* this.srs.removeOpportunity(id,this.personid)
    .subscribe(res=>
    {
      if(res.status==1)
      {
          alert('Opportunity remove from the list');
          this.router.navigate(['/student-opportunities']);
          this.getOpportunities();   
      }
    }) */
    swal({
      title: 'Are you sure you want to remove this?',
      text: "You won't be able to revert this!",
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, remove it!'
    }).then((result) => {
      if (result.value) {
        this.srs.removeOpportunity(id,this.personid)
        .subscribe(res=>
        {
          if(res.status==1)
          {
              //alert('Resource remove from the list');
              swal(
                'Removed!',
                'Opportunity has been removed.',
                'success'
              )
              this.router.navigate(['/student-opportunities']);
            this.getOpportunities();   
          }
        })
      }
    })
  }
  applied(oid)
  {
    this.srs.opportunityApplied(oid,this.personid)
    .subscribe(res=>
    {
      /* if(res.status==1)
      { */
          swal('Successfully applied.');
          this.router.navigate(['/student-opportunities']);
          this.getOpportunities(); 
     /*  } */
    })
  }

  printDiv() {

    let divName;
    if(this.currentOppId)
    {
      divName = 'printDiv'+this.currentOppId
    }
    else
    {
      divName = 'printDiv'+this.letOppId
    }
    //console.log(divName);
    let popupWinindow
    let innerContents = document.getElementById(divName).innerHTML;
    //console.log(innerContents);
    popupWinindow = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
    popupWinindow.document.open();
    popupWinindow.document.write("<html><head><style>.printpdf{margin:50px;}.printpdf .details p{margin-bottom:0; padding-bottom:0; line-height:14px;} .printpdf .details h3,.printpdf h4{color:#85b6ba;font-size:24px; text-transform: capitalize;}.printpdf h5{color: #8c8c8c; font-size: 14px; line-height: 18px; font-family: 'Roboto', sans-serif;font-weight: 600;}@page { size: auto;  margin: 0mm; }</style></head><body onload='window.print()'>" + innerContents + "</html>");
    popupWinindow.document.close();

  }

}



// WEBPACK FOOTER //
// /home/aschmidt/websites/onefuturecv.org/onefuture-frontend/src/app/pages/student-opportunities/student-opportunities.component.ts